import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import GroupRowContent from './GroupRowContent';

class GroupRow extends React.Component {
    constructor(props) {
        super(props)

        this.renderSubGroupRow = this.renderSubGroupRow.bind(this)
    }

    renderSubGroupRow(subGroups, level = 0) {
        level++;
        const {
            onAdd,
            onUpdate,
            onDelete
        } = this.props;

        return subGroups.map(subGroup => {
            let renderChildrenSubGroup;

            if (subGroup.subGroups.length > 0) {
                renderChildrenSubGroup = this.renderSubGroupRow(subGroup.subGroups, level)
            }

            return (
                <Fragment key={subGroup.id}>
                    <tr>
                        <td colSpan={2} style={{padding: `0 0 0 ${level * 30}px`}}>
                            <table className="overflow no-margin actions-right">
                                <tbody>
                                    <GroupRowContent
                                        group={subGroup}
                                        onAdd={onAdd}
                                        onUpdate={onUpdate}
                                        onDelete={onDelete}
                                    />
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    {renderChildrenSubGroup}
                </Fragment>
            )
        })
    }

    render() {
        const {
            group,
            onAdd,
            onUpdate,
            onDelete
        } = this.props;
        const hasSubGroups = group.subGroups.length > 0

        return (
            <tbody>
                <GroupRowContent
                    group={group}
                    onAdd={onAdd}
                    onUpdate={onUpdate}
                    onDelete={onDelete}
                />
                {hasSubGroups &&
                    this.renderSubGroupRow(group.subGroups)
                }
            </tbody>
        );
    }
}

GroupRow.propTypes = {
    group: PropTypes.object,
    onAdd: PropTypes.func,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
};

export default GroupRow;
